export default __webpack_public_path__ + "static/media/pin_dropoff.b0b7f0f9.svg";